import { useEffect } from "react";

import * as Sentry from "@sentry/react";
import { useNavigate, useSearchParams } from "react-router-dom";

import useUserSettings from "@app/analytics/hooks/settings/useUserSettings";
import useOnboardingStore from "@app/analytics/onboarding/hooks/useOnboardingStore";
import ROUTES from "@app/common/routes";
import { parseUrlWithParams } from "@app/common/utils";
import usePageTitle from "@app/utils/hooks/usePageTitle";

import WrapUpStepDefaultContent from "./WrapUpStepDefaultContent";
import WrapUpStepRssContent from "./WrapUpStepRssContent";

const WrapUpStep = () => {
  usePageTitle("Welcome - Wrap Up");

  const navigate = useNavigate();
  const [queryParams] = useSearchParams();
  const zoomRedirect = queryParams.get("zoomRedirect");
  const redirectTo = queryParams.get("redirectTo");
  const { context } = useOnboardingStore();
  const { updateUserMetadata } = useUserSettings();

  useEffect(() => {
    updateUserMetadata.mutate(
      { onboardingComplete: true },
      { onError: (err) => Sentry.captureException(err) }
    );
  }, []);

  const handleFinish = (
    _: React.MouseEvent,
    {
      path,
      newWindow,
    }: { path?: string; newWindow?: boolean; confetti?: boolean } = {}
  ) => {
    if (zoomRedirect) {
      window.location.href = zoomRedirect;
      return;
    }

    setTimeout(() => {
      const pathParts = parseUrlWithParams(
        path ? path : redirectTo ?? ROUTES.LANDING_PAGE
      );
      if (newWindow) {
        const url = pathParts.search
          ? `${pathParts.pathname}?${pathParts.search}`
          : pathParts.pathname;
        window.open(url);
      } else {
        navigate(pathParts);
      }
    }, 200);
  };

  const ContentComponent =
    context.source === "rss" ? WrapUpStepRssContent : WrapUpStepDefaultContent;

  return <ContentComponent context={context} onFinish={handleFinish} />;
};

export default WrapUpStep;
